var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVoltQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 5.5,
    fill: "#F0DFF2",
    stroke: "#D8B8D8",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2676 47.1757C55.7111 38.7322 55.7111 25.0628 47.2676 16.6409",
    stroke: "#BE69C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.733 16.6409C8.28952 25.0844 8.28952 38.7538 16.733 47.1757",
    stroke: "#BE69C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 52.2288C27.1837 53.0278 29.5806 53.4166 31.9992 53.4166C34.4178 53.395 36.8148 53.0278 39.1254 52.2288",
    stroke: "#BE69C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.873 11.5878C27.1837 10.7888 29.5806 10.4 31.9992 10.4C34.4178 10.4 36.8148 10.7888 39.1254 11.5878",
    stroke: "#BE69C2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2223 18.1519H44.9824V24.6313C44.9824 26.1432 45.7953 26.4492 46.7868 25.3153L53.5486 17.5759C54.3793 16.631 54.0309 15.8481 52.7714 15.8481H50.0113V9.36867C50.0113 7.8568 49.1985 7.55083 48.207 8.68473L41.4452 16.424C40.6234 17.378 40.9718 18.1519 42.2223 18.1519Z",
    fill: "#BE69C2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3553 35.432C30.3553 34.84 30.4513 34.32 30.6433 33.872C30.8353 33.424 31.0833 33.024 31.3873 32.672C31.6913 32.32 32.0113 31.992 32.3473 31.688C32.6993 31.384 33.0273 31.088 33.3313 30.8C33.6353 30.512 33.8833 30.208 34.0753 29.888C34.2673 29.568 34.3633 29.208 34.3633 28.808C34.3633 28.136 34.0913 27.592 33.5473 27.176C33.0033 26.76 32.2753 26.552 31.3633 26.552C30.4833 26.552 29.7153 26.712 29.0593 27.032C28.4193 27.352 27.8833 27.808 27.4513 28.4L25.1233 26.888C25.7953 25.976 26.6753 25.264 27.7633 24.752C28.8513 24.224 30.1393 23.96 31.6273 23.96C32.7953 23.96 33.8193 24.136 34.6993 24.488C35.5793 24.824 36.2673 25.32 36.7633 25.976C37.2593 26.616 37.5073 27.4 37.5073 28.328C37.5073 28.968 37.4033 29.528 37.1953 30.008C37.0033 30.488 36.7473 30.912 36.4273 31.28C36.1233 31.632 35.7953 31.968 35.4433 32.288C35.0913 32.592 34.7553 32.896 34.4353 33.2C34.1313 33.504 33.8833 33.832 33.6913 34.184C33.4993 34.536 33.4033 34.952 33.4033 35.432H30.3553ZM31.8913 41.168C31.3313 41.168 30.8673 40.984 30.4993 40.616C30.1473 40.248 29.9713 39.808 29.9713 39.296C29.9713 38.784 30.1473 38.352 30.4993 38C30.8673 37.632 31.3313 37.448 31.8913 37.448C32.4513 37.448 32.9073 37.632 33.2593 38C33.6113 38.352 33.7873 38.784 33.7873 39.296C33.7873 39.808 33.6113 40.248 33.2593 40.616C32.9073 40.984 32.4513 41.168 31.8913 41.168Z",
    fill: "#BE69C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoltQuestion);
export default __webpack_public_path__ + "static/media/icon_volt_question.deb0c347e2ec2a50b6f1c0bfa02852ad.svg";
export { ForwardRef as ReactComponent };